
if(!customElements.get('product-selling-plan')) {
    class ProductSellingPlan extends HTMLElement {
      constructor() {
        super();
        this.mainElement = this.closest('.section-main-product');
        this.form = this.mainElement.querySelector('form');
        this.input = this.mainElement.querySelector('[name="selling_plan"]');
        this.inputFrequencyName = this.mainElement.querySelector('[name="selling_plan_frequency"]');
        this.variantInput = this.mainElement.querySelector('[name="id"]');
        this.groupsContainer = this.querySelector('[data-groups]');
        this.plansContainer = null; //obtained after every group render
        this.textOnetime = this.dataset.textOnetime;
        this.textSubscribe = this.dataset.textSubscribe;
        this.textSubscribeSave = this.dataset.textSubscribesave;
        this.textFrequencyPlaceholder = this.dataset.textFrequencyPlaceholder;
        this.combineGroups = true;
        this.multiplyQuantity = this.dataset.multiplyQuantity == 'true';
        this.productData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.sellingPlanGroups = this.productData.sellingPlanGroups;
        this.lastSelectedSellingPlanId = this.input.value || this.sellingPlanGroups[0]?.selling_plans[0].id;
        this.customFrequencies = this.productData.customFrequencies;
        this.submitButton = this.mainElement.querySelector('[type="submit"]');

        const price = document.createElement('span');
        price.classList.add('product-form__price');
        this.submitButton.prepend(price);

        this.sellingPlanGroups.forEach((group)=>{
          group.customFrequencies = this.customFrequencies.filter((customFrequency)=>{
            return group.name.includes(customFrequency.frequency);
          });
        });

        this.input.addEventListener('change', (e)=>{
          this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
          this.updateSellingPlanHandler({detail: {sellingPlan: this.getCurrentPlan()}});
        });
  
        this.listenEvents = ['variant-change'];
        if (this.multiplyQuantity)
          this.listenEvents.push('quantityChange');
  
        this.listenEvents.forEach((event)=>{
          this.mainElement.addEventListener(event, (e)=>{
            this.groupsContainer.innerHTML = this.getGroupsHtml();
            const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(this.input.value);
            const groupId = group ? this.getHandledGroupId(group.id) : '';
            let currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+groupId+'"]');
            if (!currentGroupInput) {
              //default to another group or even the One Time purchase if this variant doesn't have Selling Plans available
              currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"]:not([value=""])') || this.groupsContainer.querySelector('[name="purchase_option"]');
            }
            let currentPlanSelect = currentGroupInput.closest('div').querySelector('.dropdown-button');

            const groupInputs = this.groupsContainer.querySelectorAll('[name="purchase_option"]');
            groupInputs.forEach(groupInput=>{
              const planSelect = groupInput.closest('div').querySelector('.dropdown-button');
              groupInput.addEventListener('change', (e)=>{
                this.updateSellingPlan(planSelect ? planSelect.dataset.id : '');
              })
              if (planSelect) {
                planSelect.addEventListener('change', (e)=>{
                  this.updateSellingPlan(e.target.value);
                });
              }
            })
            
            currentGroupInput.checked = true;
            
            if (currentPlanSelect) {
              for (let i = 0; i < currentPlanSelect.querySelectorAll('[role="option"]').length; i++) {
                const option = currentPlanSelect.querySelectorAll('[role="option"]')[i];
                if (option.dataset.id == sellingPlan.id) {
                  currentPlanSelect.querySelectorAll('[role="option"]')[i].click();
                }
              }
            }
            this.updateSellingPlan(currentPlanSelect ? currentPlanSelect.dataset.id : '');
            this.showSellingPlanDetails();
            this.initDropdown();
          });
        });

        // trigger variant-change event on initial load
        this.mainElement.dispatchEvent(new CustomEvent('variant-change'));

        
        //this.initDropdown();
        
      }

      updateSellingPlanHandler(evt) {
        //add price to the submit button
        const sellingPlan = evt.detail.sellingPlan;
        let price;
        
        if(sellingPlan){  
          price = formatMoney(sellingPlan.price);
        }else{
          const variant = this.getCurrentVariant();
          if(variant){
            price = formatMoney(variant.price);
          }
        }
        
        setTimeout(()=>{
          this.submitButton.querySelector('.product-form__price').innerHTML = price;
        }, 500)
      }

      initDropdown() {
        // Toggle dropdown visibility on button click
        this.dropdownButton = this.querySelector('.dropdown-button');
        this.dropdownList = this.querySelector('.dropdown-list');
        this.dropdownArrow = this.querySelector('.dropdown-arrow');

        this.dropdownButton.addEventListener('click', () => {
            const isExpanded = this.dropdownButton.getAttribute('aria-expanded') === 'true';
            this.dropdownButton.setAttribute('aria-expanded', !isExpanded);
            this.dropdownList.setAttribute('aria-hidden', isExpanded);
        });
        
        // Update button text when an option is selected
        this.dropdownList.querySelectorAll('li').forEach((option) => {
            option.addEventListener('click', () => {
                const selectedText = option.innerHTML; // Get selected option text
                const selectedValue = option.getAttribute('data-value'); // Get selected option value
                const selectedId = option.getAttribute('data-id'); // Get selected option value
            
                // Update button text to show selected option
                this.dropdownButton.querySelector('div').innerHTML = `${selectedText} <span id="dropdownArrow">${this.dropdownArrow.textContent}</span>`;
            
                //set dropdownButton value
                this.dropdownButton.setAttribute('data-value', selectedValue);
                this.dropdownButton.setAttribute('data-id', selectedId);
                this.input.value = selectedId;
            
                // Close dropdown
                this.dropdownButton.setAttribute('aria-expanded', 'false');
                this.dropdownList.setAttribute('aria-hidden', 'true');

                this.inputFrequencyName.value = selectedValue;
                this.input.dispatchEvent(new Event('change', {bubbles: true}));

            });
        });
        
        // Handle keyboard navigation
        this.dropdownList.addEventListener('keydown', (e) => {
            const focusableElements = this.dropdownList.querySelectorAll('li');
            let index = Array.prototype.indexOf.call(focusableElements, document.activeElement);
        
            switch (e.key) {
            case 'ArrowDown':
                index = (index + 1) % focusableElements.length;
                focusableElements[index].focus();
                break;
            case 'ArrowUp':
                index = (index - 1 + focusableElements.length) % focusableElements.length;
                focusableElements[index].focus();
                break;
            case 'Enter':  // Select option on Enter key
                focusableElements[index].click();
                break;
            case 'Escape':
                this.dropdownButton.focus();
                this.dropdownButton.setAttribute('aria-expanded', 'false');
                this.dropdownList.setAttribute('aria-hidden', 'true');
                break;
            }
        });
      }
  
      getSellingPlanByIdWithGroup(id) {
        for (let i=0; id && i < this.sellingPlanGroups.length; i++) {
          const group = this.sellingPlanGroups[i];
          const sellingPlan = group.selling_plans.find(x=>x.id==id)
          if (sellingPlan) {
            return {sellingPlan, group}
          }
        }
        return {sellingPlan: null, group: null};
      }
  
      getHandledGroupId(groupId) {
        return this.combineGroups ? 'subscribe' : groupId;
      }

      getCurrentVariant() {
        return this.productData.variants.find(x=>x.id==this.variantInput.value)       
      }
  
      showSellingPlanDetails() {
        const currentVariant = this.getCurrentVariant();
        
        const groupLabels = this.groupsContainer.querySelectorAll('[name="purchase_option"]:not([value=""]) + label');
        groupLabels.forEach(label=>{
          const planSelect = label.closest('div').querySelector('.dropdown-button');
          const planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==planSelect.dataset.id);
          const quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
          const discount = planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price ? Math.round(100 - planAlloc.price/planAlloc.compare_at_price*100) : 0;
          const optionPrice = formatMoney(planAlloc.price * quantity);
          label.innerHTML = `<div class="option-subscribe">` + (discount ? this.textSubscribeSave + ' <span class="option-discount">'+discount+'% Savings</span>' : this.textSubscribe) + `<span class="option-price">${optionPrice}</span></div>`;
        });
        return;
      }
  
      updateSellingPlan(sellingPlanId) {
        this.input.value = sellingPlanId;
        if (sellingPlanId) {
          this.mainElement.lastSelectedSellingPlanId = sellingPlanId;
          const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(sellingPlanId);
          this.inputFrequencyName.value = sellingPlan.name;
        } else {
          this.inputFrequencyName.value = '';
        }
        this.showSellingPlanDetails();
        this.input.dispatchEvent(new Event('change', {bubbles: true}));
      }
  
      getGroupsHtml() {
        var showFrequency = false;
        var currentVariant = this.getCurrentVariant();
        var html = '';
        var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        
        if(currentVariant) {
          currentVariant.selling_plan_allocations.forEach((planAlloc, ix)=>{
            
            if (this.combineGroups && ix>0) {
              return;
            }
            const group = this.productData.sellingPlanGroups.find(x=>x.id==planAlloc.selling_plan_group_id);
            if (!group) {
              //current variant doesn't support this selling plan group;
              return;
            }
  
            const groupId = this.getHandledGroupId(group.id);
            let optionId = `plan-option-${groupId}-${this.mainElement.dataset.section}`;
            html += `
              <div>
                <input class="radio-custom" type="radio" name="purchase_option" value="${groupId}" id="${optionId}">
                <label class="radio-custom-label" for="${optionId}">Subscribe</label>
                <div data-plans class="${!showFrequency ? 'frequency-hidden': ''}">${this.getPlansHtml(group)}</div>
                ${this.getPoliciesHtml(planAlloc)}
              </div>
            `;
          });
        }

        if(!this.productData.requiresSellingPlan) {
            let optionId = `plan-option-onetime-${this.mainElement.dataset.section}`;
            let optionPrice = formatMoney(currentVariant.price * quantity);
            html += `
                <div>
                    <input class="radio-custom" type="radio" name="purchase_option" value="" id="${optionId}">
                    <label class="radio-custom-label" for="${optionId}"><div>${this.textOnetime}<span class="option-price">${optionPrice}</span></div></label>
                </div>
            `;
        }
  
        if(currentVariant.selling_plan_allocations.length==0) {
          this.groupsContainer.classList.add('hide');
        }else {
          this.groupsContainer.classList.remove('hide');
        }
  
        return html;
      }

      getPoliciesHtml(planAlloc) {
        let html = ``;
        const discount = planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price ? Math.round(100 - planAlloc.price/planAlloc.compare_at_price*100) : 0;
        
        const policies = [];policies.push("[discount]% Off ALL Recurring Orders".replace('[discount]',discount));policies.push("Pause/Swap/Cancel Anytime".replace('[discount]',discount));policies.push("Free Shipping".replace('[discount]',discount));policies.push("30 Day Satisfaction Guarantee".replace('[discount]',discount));html += `<div class="policies">`;
        policies.forEach((policy)=>{
          html += `
            <div class="policy flex">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M3.4733 8.07373L5.80663 10.4071L11.64 4.57373" stroke="#234237" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>${policy}</span>
            </div>`;
        });

        html += `</div>`

        return html;
      }
  
      getPlansHtml(group) {
        //functionalities:
        // show or hide frequency dropdown when the One-Time option is selected
        // show a div with the frequency option when there is a single option but keep the <select> hidden
        //
        var currentVariant = this.getCurrentVariant();
        var enabled = this.input.value!='';
  
        var html = '';
        
        const groupPlanAllocations = this.combineGroups ? currentVariant.selling_plan_allocations : currentVariant.selling_plan_allocations.filter(x=>x.selling_plan_group_id==group.id);
        var isOneOption = groupPlanAllocations.length==1;
        html = `
        <div class="dropdown-container ${isOneOption ? 'hide' : ''}">
        
        <button class="dropdown-button" aria-haspopup="true" aria-expanded="false" aria-controls="dropdownList" for="frequency-${currentVariant.id}" data-value="${group.name}" data-id="${ groupPlanAllocations[0].selling_plan_id }">
            <div>${this.textFrequencyPlaceholder}</div> <span class="dropdown-arrow"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron rotate-90" width="17" height="17" viewBox="0 0 11 17" fill="none"> <path d="M1.5 0.999995L9.5 8.26521L1.5 15.5304" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/> </svg></span>
        </button>
        <ul id="frequency-${currentVariant.id}" role="listbox" aria-hidden="true" class="dropdown-list ${enabled ? 'enabled' : ''}">`;
        
        groupPlanAllocations.forEach((plan)=>{
          const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(plan.selling_plan_id);
          const frequency = sellingPlan.options[1]?.value.split('-')[0]; 
          let frequencyUnit = sellingPlan.options[1]?.value.split('-')[1]; 

          if (frequency > 1) {
            frequencyUnit = frequencyUnit + 's';
          }

          html += `
          <li tabindex="0" role="option" data-value="${sellingPlan.name}" data-id="${sellingPlan.id}">
            <div class="flex option-container">
                ${(group.customFrequencies.length > 0 && group.customFrequencies[0].image) ? `<img src="${group.customFrequencies[0].image}" alt="${group.customFrequencies[0].text}" />` : (this.productData.frequencyImage) ? `<img src="${this.productData.frequencyImage}" alt="" />` : ``}
                <div class="flex-1">
                    ${(group.customFrequencies.length > 0) ? `<strong>${group.customFrequencies[0].text}</strong>` : `<strong>${sellingPlan.name}</strong>`}
                    <span>Ships every ${frequency} ${frequencyUnit}</span>
                </div>
            </div>
          </li>`;
        });
        html += `</ul></div>`;
        if (isOneOption) {
          html += `<div class="selling-plan-name">${group.selling_plans[0].name}</div>`;
        }
  
        return html;
      }
  
      getCurrentPlan() {
        var currentVariant = this.getCurrentVariant();
        if(currentVariant) {
          return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
        }
        return false;
      }
  
    }
    customElements.define('product-selling-plan', ProductSellingPlan);
  }
